'use strict';

import {Dialog} from './dialog.js';

export class DialogVipguidewhy extends Dialog {
	constructor(component_key) {
		super(component_key);
	}

	on_show() {
		jQuery('html').addClass('js-no_scroll');
		setTimeout(() => {
			jQuery(`.js-${this.id}_position`).addClass('js-active');
		}, 50);
	}

	on_close() {
		jQuery(`.js-${this.id}_position`).removeClass('js-active');
		jQuery('html').removeClass('js-no_scroll');
	}
}
